;(function($, undefined){
    "use strict";

    var rnn, log;

    function initRealEstate() {
        var $form = $('#realestateSearch');

        if ($form.length > 0) {
            realEstatePrices($form);
            
            $form.on('change', '#disposalMethod', function () {
                realEstatePrices($form);
            });
        }
    }

    function realEstatePrices($form) {
        var $select = $form.find('#disposalMethod'),
            val = $select.val(),
            $prices = $form.find('#priceMinimum, #priceMaximum'),
            selected;
            
        if (typeof propertyPrices !== 'undefined') {
            selected = propertyPrices[val];
        }
        if (selected) {   
            $prices.find('option[value!="0"]').remove();
            $.each(selected, function (i, item) {
                $prices.append($('<option>', {
                    value: item.price,
                    text: item.label
                }));
            });
        }
    }

    function initSubmit() {
        $('.container-search form').each(function () {
            
            $(this).on('change', 'select', function () {
                var val = $(this).val();
                if (val !== '' && val != '0') {
                    $(this).addClass('selected');
                } else {
                    $(this).removeClass('selected');
                }
            }).submit(function (e) {
                e.preventDefault();

                var $form = $(this),
                    url = $form.attr('action'),
                    queryString = '',
                    keywords = $form.find('.keywords').val(),
                    error = false;

                $form.find('select, input[type="text"]:not(.keywords)').each(function () {
                    var val = $(this).val(),
                        prefix = $(this).data('prefix');
                    
                    // if the select is part of a range and the range has a maximum field
                    if ($(this).data('range') === true) {
                        if ($(this).data('range-maximum')) {
                            var $maxElement = $form.find($(this).data('range-maximum')),
                                val2 = $maxElement.val();

                            // helps this work with selects and inputs
                            if (val === '') val = '0';
                            if (val2 === '') val2 = '0';
                            
                            if (val != "0" || val2 != "0") {
                                if (queryString) {
                                    queryString += "&"; 
                                } else {
                                    queryString += "?";
                                }
                                queryString += prefix + "=";  

                                queryString += val + "-";
                                if (val2 != "0") { 
                                    queryString += val2;

                                    // validation to check if the max is smaller than the min
                                    if (parseInt(val2) < parseInt(val)) {
                                        error = true;
                                        $maxElement.addClass('error').tooltip({
                                            placement: 'bottom',
                                            trigger: 'manual',
                                            container: 'body',
                                            title: 'The maximum price needs to be greater than the minimum price'
                                        }).tooltip('show');
                                        $('body').one('click', function () {
                                            $maxElement.removeClass('error').tooltip('destroy');
                                        });
                                    }
                                }
                            }
                        }
                    } else {
                        if (val) {
                            if (prefix) {
                                url += prefix + '-';
                            }
                            url += val + '/';
                        }
                    }
                });

                if (keywords) {
                    if (queryString) {
                        queryString += "&"; 
                    } else {
                        queryString += "?";
                    }
                    queryString += "keywords=" + keywords;   
                }
                if (!error) {
                    document.location.href = url + queryString;
                }
                return false;

            });
        });
    }

    function initSearchContainers() {
        initRealEstate();
        initSubmit();
    }

    rnn = window.rnn;
    log = rnn.logging.log;

    rnn.modules.register("searchContainers", {
        init: initSearchContainers
    });

})(jQuery);
